/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Limit_3_ValueInputs */

const en_svc_agents_limit_3_value = /** @type {(inputs: Svc_Agents_Limit_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every run is recorded, and exceptions go to a named owner.`)
};

const lv_svc_agents_limit_3_value = /** @type {(inputs: Svc_Agents_Limit_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katrs darbs tiek reģistrēts, un izņēmumi nonāk pie atbildīgā cilvēka.`)
};

/**
* | output |
* | --- |
* | "Every run is recorded, and exceptions go to a named owner." |
*
* @param {Svc_Agents_Limit_3_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_limit_3_value = /** @type {((inputs?: Svc_Agents_Limit_3_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Limit_3_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_limit_3_value(inputs)
	return en_svc_agents_limit_3_value(inputs)
});